import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { MonthActionsPropertiesType } from "@website/ui/datepicker/components/month-actions/month-actions.types";
export const useMonthActions = properties => {
  const $ = _c(13);
  const {
    calendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MaterialIcon name="chevron_left" variant="outlined" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = calendarLocale === "persian" ? "\u0646\u0645\u0627\u06CC\u0634 \u0645\u0627\u0647 \u0642\u0628\u0644" : "show-previous-month";
  let t2;
  if ($[1] !== previousMonthDisabled || $[2] !== showPreviousMonth || $[3] !== t1) {
    t2 = {
      onClick: showPreviousMonth,
      EndIcon: t0,
      color: "neutral" as const,
      size: "small" as const,
      variant: "text" as const,
      "aria-label": t1,
      equalDimension: true,
      disabled: previousMonthDisabled
    };
    $[1] = previousMonthDisabled;
    $[2] = showPreviousMonth;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon name="chevron_right" variant="outlined" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = calendarLocale === "persian" ? "\u0646\u0645\u0627\u06CC\u0634 \u0645\u0627\u0647 \u0628\u0639\u062F" : "show-next-month";
  let t5;
  if ($[6] !== nextMonthDisabled || $[7] !== showNextMonth || $[8] !== t4) {
    t5 = {
      onClick: showNextMonth,
      EndIcon: t3,
      color: "neutral" as const,
      size: "small" as const,
      variant: "text" as const,
      "aria-label": t4,
      equalDimension: true,
      disabled: nextMonthDisabled
    };
    $[6] = nextMonthDisabled;
    $[7] = showNextMonth;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = {
      showPreviousMonthButtonProperties: t2,
      showNextMonthButtonProperties: t5
    };
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};